import { MenuWithChildren } from '../../types/menu';

export const ADMIN_REGISTER_MENUS: MenuWithChildren[] = [
  {
    id: 1,
    display_name: 'Become Academy Admin',
    location: 'Header',
    link: '/register-institute',
  },
  {
    id: 2,
    display_name: 'Become Scholarship Provider',
    location: 'Header',
    link: '/register-scholarship-provider',
  },
];
